import SwedBank from "./SwedBank";
import PaymentSystems from "./PaymentSystems";

const Payment = {
  SwedBank,
  PaymentSystems,
};

export default Payment;
